module.exports = __webpack_public_path__ + "img/BOTON-SIGUIENTE-OVER.d8adbbf8.svg";